export default __webpack_public_path__ + "static/media/iron.c38553b3.svg";